import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { FunnelStepId, FunnelStepInterface } from '../types/funnel-step-interface'
import { FunnelPageTemplateId } from '../types/funnel-page-template-interface'
import { FUNNELS_API } from '../../api/funnels-api'

export const useSelectPageTemplate = () => {
  const { fetcher: postFetcher, isFetching } = useFetch<
    RequestMethodsEnum.post,
    FunnelStepInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const selectPageTemplate = (id: FunnelStepId, pageTemplateId: FunnelPageTemplateId) =>
    postFetcher(`${FUNNELS_API}/steps/${id}/templates/${pageTemplateId}/choose`)

  return { selectPageTemplate, isFetching }
}
